const poiElements = [
    {
        label: 'Favoriten',
        name: 'Favoriten',
        slug: 'favoriten',
        value: 'favourites',
        icon: 'IconStar',
        apiType: 'favorites',
        trackingLabel: 'Favorites',
        trackingValue: 'favorites',
        categories: [
            {value: 'home', label: 'Zuhause', labelAlt: 'Zuhause', imageName: 'home',},
            {value: 'work', label: 'Arbeit', labelAlt: 'Arbeit', imageName: 'work',},
            {value: 'ADDRESS', label: 'Ort', labelAlt: 'Ort', imageName: 'location',},
            {value: 'PARTNER', label: 'Vorteilspartner', labelAlt: 'Vorteilspartner', imageName: 'partner',}, // some old favourites just have partner as category
            {value: 'sights', label: 'Sehenswürdigkeit', labelAlt: 'Sehenswürdigkeit', imageName: 'icon-sight',}, // some Meine-Reise-App do not have a subtype for Sehenswertes
        ]
    },
    {
        label: 'Verkehr',
        name: 'Verkehr',
        slug: 'verkehrslage',
        value: 'traffic',
        icon: 'IconTraffic',
        apiType: 'traffic',
        trackingLabel: 'Traffic',
        trackingAction: 'Select',
        trackingCategory: 'Traffic',
        trackingValue: 'traffic',
        favouriteType: 'TRAFFIC',
        categories: [
            {value: 'Verkehrsfluss', label: 'Verkehrsfluss', imageName: 'icon-verkehr-verkehrsfluss', skipParam: true, trackingLabel: 'Traffic Flows'},
            {
                value: 'Verkehrsbehinderungen', label: 'Staus & Verkehrsbehinderungen', imageName: 'icon-verkehr-stau', 
                children: [ // mapping subcategories to one setting in settings panel
                    {'value': 'Störung', imageName: 'icon-verkehr-dreieck'},
                    {'value': 'Verkehr', imageName: 'icon-verkehr-dreieck'},
                    {'value': 'Stau', imageName: 'icon-verkehr-stau'},
                    {'value': 'Straßenzustand', imageName: 'icon-verkehr-stra-enzustand'},
                ],
                trackingLabel: 'Traffic Jams'
            },
            {
                value: 'Sperren', label: 'Sperren & Wintersperren', imageName: 'icon-verkehr-sperre', 
                children: [
                    {'value': 'Wintersperre', imageName: 'icon-verkehr-wintersperre'},
                    {'value': 'Sperre', imageName: 'icon-verkehr-sperre'},
                ],
                trackingLabel: 'Barriers'
            },
            {value: 'Baustelle', label: 'Baustellen', imageName: 'icon-verkehr-baustelle', trackingLabel: 'Construction Sites'},
            {value: 'CAMERA', label: 'Verkehrskameras', labelAlt: 'Verkehrskamera', imageName: 'icon-verkehr-webcam', apiType: 'camera', favouriteType: 'CAMERA', slug: 'camera', trackingLabel: 'Traffic Cameras'},
            {value: 'Schneeketten', label: 'Schneekettenpflichten', imageName: 'icon-verkehr-schneekette', trackingLabel: 'Mandatory Snow Chains'},
            {value: 'Prognose', label: 'Verzögerung zu erwarten', imageName: 'icon-verkehr-prognose-leicht', hideInOptions: true, trackingLabel: 'Prognose',
                children: [
                    {value: 'PrognoseOrange', label: 'Zäher Verkehr zu erwarten', imageName: 'icon-verkehr-prognose-mittel'},
                    {value: 'PrognoseRot', label: 'Stau zu erwarten', imageName: 'icon-verkehr-prognose-schwer'},
                ]
            },
        ]
    },
    {
        label: 'Tanken',
        name: 'Tanken',
        detailName: 'Tankstelle',
        slug: 'tanken',
        value: 'gasStations',
        icon: 'IconGasStation',
        apiType: 'fuel',
        trackingAction: 'Select',
        trackingCategory: 'Gas Stations',
        trackingLabel: 'Gas Stations',
        trackingValue: 'gas_stations',
        favouriteType: 'FUEL',
        imageName: 'gasstation-default',
        categories: null,
        types: [
            {label: 'Super', value: 'GASOLINE_SUPER'},
            {label: 'Diesel', value: 'DIESEL'},
            // {label: 'Strom', value: 'Strom'}, // todo: get correct value (wasn't listed in API docs)
            {label: 'Normal', value: 'GASOLINE'},
            {label: 'Super Plus', value: 'GASOLINE_SUPER_PLUS'},
            {label: 'Premium Benzin', value: 'GASOLINE_PREMIUM'},
            {label: 'Premium Diesel', value: 'DIESEL_PREMIUM'},
            {label: 'Biodiesel', value: 'BIODIESEL'},
            {label: 'Erdgas (CNG)', value: 'NATURAL_GAS'},
            {label: 'Autogas (LPG)', value: 'AUTOGAS'},
            {label: 'Wasserstoff', value: 'HYDROGEN'},
            {label: 'AdBlue PKW - Zapfsäule', value: 'ADBLUE'},
            { label: 'HVO 100', value: 'HVO100' }
        ]
    },
    {
        label: 'Laden',
        name: 'Ladestationen',
        detailName: 'Ladestation',
        slug: 'laden',
        value: 'chargingStations',
        icon: 'IconChargingStation',
        apiType: 'efuel',
        trackingAction: 'Select',
        trackingCategory: 'Charging Station',
        trackingLabel: 'Charging Station',
        trackingValue: 'charging_stations',
        favouriteType: 'EFUEL',
        imageName: 'icon-efuel',
        categories: [
          { value: 'default', label: 'Default', imageName: 'icon-efuel', },
          { value: 'oeamtc-e-power', label: 'Öeamtc', imageName: 'icon-efuel-oeamtc' } 
        ],
        plugs: [
            { label: 'Typ 2', value: 'TYP2', icon: 'IconType2', trackingLabel: 'Typ 2' },
            { label: 'CCS', value: 'CCS_TYP2', icon: 'IconCCS2', trackingLabel: 'CCS'  },
            { label: 'CHAdeMO', value: 'CHA_DE_MO', icon: 'IconCHAdeMO', trackingLabel: 'chademo' },
            { label: 'Typ 1', value: 'TYP1', icon: 'IconType1', trackingLabel: 'Typ 1' },
            { label: 'Schuko', value: 'SCHUKO_PLUG', icon: 'IconSchuko', trackingLabel: 'Schuko' },
            { label: 'CEE', value: 'CEE_THREE_POLE', icon: 'IconCEEthreePole', subValues:[ 'CEE_FIVE_POLE' ], trackingLabel: 'CEE' },
            // { label: 'CCS/Combo 1', value: 'CCS_TYP1', icon: 'IconCCS1' },
            // { label: 'CEE 5-polig', value: 'CEE_FIVE_POLE', icon: 'IconCEEfivePole' },
            // { label: 'Tesla Supercharger', value: 'TESLA', icon: 'IconTesla' },
            { label: 'Sonstige', value: 'UNKNOWN', icon: 'IconChargingStation', subValues: [ 'IEC_60309-2_RED_32A', 'TYP3', 'TESLA', 'CCS_TYP1' ], trackingLabel: 'Other' },
        ]
    },
    {
        label: 'Umwelt&shy;zonen',
        name: 'Umweltzonen',
        detailName: 'Umweltzone',
        slug: 'umweltzonen',
        value: 'greenzone',
        icon: 'IconEnvironmentZone',
        apiType: 'greenzone',
        trackingLabel: 'Environmental Zone',
        trackingAction: 'Select',
        trackingCategory: 'Environmental Zone',    
        trackingValue: 'environmental_zone',
        imageName: 'icon-umweltzone',
    },
    {
        label: 'Parken',
        name: 'Parken',
        slug: 'parken',
        value: 'carParks',
        icon: 'IconParking',
        apiType: 'parking',
        trackingLabel: 'Parking',
        trackingValue: 'parking',
        favouriteType: 'PARKING',
        categories: [ // used also in settings popup
            {value: 'OPEN_SPACE', label: 'Offene Flächen', labelAlt: 'Offene Fläche', imageName: 'open-space', trackingLabel: 'Outdoor Parking'},
            {value: 'PARK_AND_RIDE', label: 'Park & Ride', labelAlt: 'Park & Ride', imageName: 'park-ride', trackingLabel: 'Park & Ride'},
            { value: 'PARK_AND_DRIVE', label: 'Park & Drive', labelAlt: 'Park & Drive', imageName: 'park-drive', trackingLabel: 'Park & Drive' },
            {
                value: 'SHORTTERMPARKING', 
                label: 'Kurzparkzonen (Flächen)', 
                labelAlt: 'Kurzparkzone', 
                imageName: 'short-term', 
                apiType: 'shorttermparking', 
                favouriteType: 'SHORTTERMPARKING',
                slug: 'kurzparkzonen',
                trackingLabel: 'Kurzparkzonen',
                children: [
                    { value: 'PUBLIC', label: 'Kurzparkzonen (Flächen)', labelAlt: 'Kurzparkzone', imageName: 'short-term'},
                    { value: 'NON_PUBLIC', label: 'Anrainerparkzone', labelAlt: 'Anrainerparkzone', imageName: 'anrainer'},
                ],
            },
            {value: 'PARKING_GARAGE', label: 'Parkgaragen', labelAlt: 'Parkgarage', imageName: 'parking-garage', trackingLabel: 'Garage'},
            {value: 'BUS_PARKING', label: 'Busse', labelAlt: 'Bus', imageName: 'buses', trackingLabel: 'Bus'},
        ],
        operators: [ // used also in settings popup
            {label: 'APCOA', value: 'APCOA PARKING Austria GmbH'},
            {label: 'WIPARK', value: 'WIPARK Garagen GmbH'},
            {label: 'BIP', value: 'Best in Parking & Real Estate AG'},
            {label: 'BOE', value: 'BOE'},
            {label: 'CONTIPARK', value: 'Contipark International Austria GmbH'},
            {label: 'Diverse', value: 'Diverse'},
        ],
    },
    {
        label: 'Haltestellen',
        name: 'Haltestellen',
        detailName: 'Haltestelle',
        slug: 'haltestellen',
        value: 'nearbyStations',
        icon: 'IconTrainStation',
        apiType: 'nearbyStations',
        trackingLabel: 'Stations',
        trackingAction: 'Select',
        trackingCategory: 'Stations',
        trackingValue: 'stations',
        imageName: 'nearby-stations',
        favouriteType: 'PUBLICTRANSPORT',
    },
    {
        label: 'Reise-Radar',
        name: 'Reise-Radar',
        slug: 'reise-radar',
        value: 'travelRadar',
        icon: 'IconTravelRadar',
        trackingLabel: 'Travel Warning',
        trackingAction: 'Select',
        trackingCategory: 'Travel Warning',
        trackingValue: 'travel_warning',
        apiType: 'travel-alert',
        categories: [ // translates to level in API
            {value: 'NOT_EVALUATED', label: 'nicht evaluiertes Risiko', labelAlt: 'nicht evaluiertes Risiko', imageName: 'icon-very-weak',},
            {value: 'VERY_LOW', label: 'sehr geringes Risiko', labelAlt: 'sehr geringes Risiko', imageName: 'icon-very-weak',},
            {value: 'LOW', label: 'geringes Risiko', labelAlt: 'geringes Risiko', imageName: 'icon-weak',},
            {value: 'ELEVATED', label: 'erhöhtes Risiko', labelAlt: 'erhöhtes Risiko', imageName: 'icon-mid',},
            {value: 'HIGH', label: 'hohes Risiko', labelAlt: 'hohes Risiko', imageName: 'icon-high',},
            {value: 'VERY_HIGH', label: 'sehr hohes Risiko', labelAlt: 'sehr hohes Risiko', imageName: 'icon-very-high',},
        ]
    },
    {
        label: 'Sehens&shy;wertes',
        name: 'Sehenswertes',
        slug: 'sehenswertes',
        value: 'sights',
        trackingLabel: 'Sights',
        trackingCategory: 'Sights',
        trackingAction: 'Select',
        trackingValue: 'sights',
        icon: 'IconSights',
        apiType: 'sight',
        favouriteType: 'SIGHT',
        imageName: 'icon-sight',
        categories: [
            {value: 'BUILDING', label: 'Bauwerke', labelAlt: 'Bauwerk', imageName: 'icon-buildings', trackingLabel: 'Building'},
            {value: 'MUSEUM', label: 'Museen', labelAlt: 'Museum', imageName: 'icon-museum', trackingLabel: 'Museum'},
            {value: 'NATURE', label: 'Natur', labelAlt: 'Natur', imageName: 'icon-nature',  trackingLabel: 'Nature'},
            {value: 'ENTERTAINMENT', label: 'Unterhaltung', labelAlt: 'Unterhaltung', imageName: 'icon-entertainment', trackingLabel: 'Entertainment'},
            {value: 'RESTAURANT', label: 'Essen', labelAlt: 'Essen', imageName: 'icon-food', trackingLabel: 'Food'},
            {value: 'TOURIST_INFORMATION', label: 'Touristen-Info', labelAlt: 'Touristen-Info', imageName: 'icon-tourist-info', trackingLabel: 'Info Point'},
            {value: 'AIRPORT', label: 'Flughäfen', labelAlt: 'Flughafen', imageName: 'icon-airport', trackingLabel: 'Airport'},
            {value: 'TRAIN_STATION', label: 'Bahnhöfe', labelAlt: 'Bahnhof', imageName: 'icon-train-station', trackingLabel: 'Train Station'},
        ]
    },
    {
        label: 'ÖAMTC Standorte',
        name: 'ÖAMTC Standorte',
        slug: 'oeamtc-standorte',
        value: 'oeamtcLocations',
        icon: 'IconOEAMTC',
        apiType: 'oeamtc',
        trackingLabel: 'ÖAMTC Offices',
        trackingAction: 'Select',
        trackingCategory: 'ÖAMTC Offices',
        trackingValue: 'oeamtc_offices',
        favouriteType: 'OEAMTC',
        categories: [ // used also in settings popup
            {value: 'BASE', label: 'Stützpunkte', labelAlt: 'Stützpunkt', imageName: 'icon-oeamtc-stuetzpunkte',},
            {value: 'BICYCLE_STATION', label: 'Fahrrad-Stationen', labelAlt: 'Fahrrad-Station', imageName: 'icon-oeamtc-fahrrad-stationen',},
            {value: 'TRAVEL_AGENCY', label: 'Reisebüros', labelAlt: 'Reisebüro', imageName: 'icon-oeamtc-reisebueros',},
            {value: 'DRIVING_SKILLS_CENTER', label: 'Fahrtechnikzentren', labelAlt: 'Fahrtechnikzentrum', imageName: 'icon-oeamtc-fahrtechnikzentrum',},
            {value: 'MOBILITY_PARK', label: 'Mobilitätsparks', labelAlt: 'Mobilitätspark', imageName: 'icon-oeamtc-mobilitaetspark',},
            {value: 'BORDER_STATION', label: 'Grenzstationen', labelAlt: 'Grenzstation', imageName: 'icon-oeamtc-grenzstation',},
            {value: 'STATE_CLUB', label: 'Landesclubs', labelAlt: 'Landesclub', imageName: 'icon-oeamtc-landesclub',},
            {value: 'CHRISTOPHORUS_BASE', label: 'Christophorus-Standorte', labelAlt: 'Christophorus-Standort', imageName: 'icon-oeamtc-christopherus',},
        ]
    },
    {
        label: 'Vorteils&shy;partner',
        name: 'Vorteilspartner',
        slug: 'vorteilspartner',
        value: 'partners',
        icon: 'IconPercentage',
        apiType: 'partner',
        trackingLabel: 'Partner',
        trackingCategory: 'Partners',
        trackingAction: 'Select',
        trackingValue: 'partner',
        categories: [ // used also in settings popup
            {value: 'ENTERTAINMENT', label: 'Bühnen & Festivals', labelAlt: 'Bühnen & Festivals', imageName: 'icon-entertainment', apiType: 'entertainment', favouriteType: 'ENTERTAINMENT', slug: 'unterhaltung', trackingLabel: 'Theater & Festivals'},
            {value: 'SHOPPING', label: 'Einkauf', labelAlt: 'Einkauf', imageName: 'icon-shopping', apiType: 'shopping', favouriteType: 'SHOPPING', slug: 'einkaufen', trackingLabel: 'Shopping'},
            {value: 'GASTRONOMY', label: 'Essen & Trinken', labelAlt: 'Essen & Trinken', imageName: 'icon-gastronomy', apiType: 'gastronomy', favouriteType: 'GASTRONOMY', slug: 'essen-trinken', trackingLabel: 'Food & Drink'},
            {value: 'LEISURE', label: 'Freizeit & Kultur', labelAlt: 'Freizeit & Kultur', imageName: 'icon-leisure', apiType: 'leisure', favouriteType: 'LEISURE', slug: 'freizeit-kultur', trackingLabel: 'Culture'},
            {value: 'ACCOMMODATION', label: 'Hotels & Wellness', labelAlt: 'Hotels & Wellness', imageName: 'icon-accommodation', apiType: 'accommodation', favouriteType: 'ACCOMMODATION', slug: 'hotel-wellness', trackingLabel: 'Hotels & Wellness'},
            {value: 'MOBILITY', label: 'Mobilität', labelAlt: 'Mobilität', imageName: 'icon-mobility', apiType: 'mobility', favouriteType: 'MOBILITY', slug: 'mobilitaet', trackingLabel: 'Mobility'},
            {value: 'SPORTS', label: 'Sport & Freizeit', labelAlt: 'Sport & Freizeit', imageName: 'icon-sports', apiType: 'sports', favouriteType: 'SPORTS', slug: 'sport-freizeit', trackingLabel: 'Sport'},
        ],
    },
    {
        label: 'Raststätten',
        name: 'Raststätten',
        detailName: 'Raststätte',
        slug: 'raststaetten',
        value: 'roadHouses',
        icon: 'IconReststop',
        imageName: 'icon-roadhouse',
        apiType: 'roadhouse',
        trackingLabel: 'Service Station',
        trackingAction: 'Select',
        trackingCategory: 'Service Station',
        trackingValue: 'service_station',
        favouriteType: 'ROADHOUSE',
    },
    {
        label: 'Mautstraßen',
        name: 'Mautstraßen',
        detailName: 'Mautstraße',
        slug: 'mautstrassen',
        value: 'tollRoads',
        icon: 'IconToll',
        apiType: 'specialtollroad',
        trackingLabel: 'Toll',
        trackingAction: 'Select',
        trackingCategory: 'Toll',
        trackingValue: 'toll',
        favouriteType: 'SPECIALTOLLROAD',
        imageName: 'icon-tollRoad',
    },
    {
        label: 'Tunnel',
        name: 'Tunnel',
        detailName: 'Tunnel',
        slug: 'tunnel',
        value: 'tunnels',
        icon: 'IconTunnel',
        apiType: 'tunnel',
        trackingLabel: 'Tunnel',
        trackingAction: 'Select',
        trackingCategory: 'Tunnel',
        trackingValue: 'tunnel',
        favouriteType: 'TUNNEL',
        imageName: 'icon-tunnel',
    },
    {
        label: 'Berg- und Passstraßen',
        name: 'Berg- und Passstraßen',
        detailName: 'Berg- und Passstraße',
        slug: 'berg-passstrassen',
        value: 'passRoads',
        icon: 'IconMountainRoad',
        imageName: 'icon-mountain-road',
        apiType: 'passroad',
        trackingLabel: 'Mountain Road',
        trackingAction: 'Select',
        trackingCategory: 'Mountain Road',
        trackingValue: 'mountain_road',
        favouriteType: 'PASSROAD',
    },
    {
        label: 'Camping',
        name: 'Camping',
        slug: 'camping',
        value: 'camping',
        icon: 'IconCamping',
        apiType: 'camping',
        trackingLabel: 'Camping',
        trackingAction: 'Select',
        trackingCategory: 'Camping',
        trackingValue: 'camping',
        favouriteType: 'CAMPING',
        categories: [ // used also in settings popup
            {value: 'CAMPING', label: 'Campingplätze', labelAlt: 'Campingplatz', imageName: 'camping', trackingLabel: 'Camping Area'},
            {value: 'CAMPER', label: 'Wohnmobilstellplätze', labelAlt: 'Wohnmobilstellplatz', imageName: 'camper', trackingLabel: 'Camper Area'},
            {value: 'OECC', label: 'Nur ÖCC-Campingplätze', labelAlt: 'ÖCC-Campingplatz', imageName: 'oecc', format: 'png', trackingLabel: 'CC Camping Area'}
        ]
    },
    // Note: tracking is currently missing for everything commented below
    // {
    //     label: 'easyway Roller',
    //     name: 'easyway Roller',
    //     slug: 'easyway-roller',
    //     value: 'roller',
    //     icon: 'IconEasyWay',
    // },
    // {
    //     label: 'Fahrrad',
    //     name: 'Fahrrad',
    //     slug: 'fahrrad',
    //     value: 'bikes',
    //     icon: 'IconBike',
    // },
    // {
    //     label: 'Behörden',
    //     name: 'Behörden',
    //     slug: 'behoerden',
    //     value: 'officials',
    //     icon: '',
    // },
    // {
    //     label: 'Gesundheit',
    //     name: 'Gesundheit',
    //     slug: 'gesundheit',
    //     value: 'health',
    //     icon: 'IconHealth',
    //     apiType: 'health',
    // },
    // {
    //     label: 'Wetter',
    //     name: 'Wetter',
    //     slug: 'wetter',
    //     value: 'weather',
    //     icon: 'IconWeather',
    // },
];

export default poiElements;